<template>
  <div class="tournament-carousel">
    <h2 class="title-lined">
      <div class="title-line">campeonatos</div>
    </h2>
    <vue-glide v-if="tournaments.length > 0" type="carousel" :autoplay="4000" :perView="1">
      <vue-glide-slide v-for="tournament in tournaments" :key="tournament.slug">
        <TournamentCard :tournament="tournament"></TournamentCard>
      </vue-glide-slide>
    </vue-glide>
  </div>
</template>

<script>
import { Glide, GlideSlide } from "vue-glide-js";
import TournamentCard from "@/components/TournamentCard";

export default {
  name: "TournamentCarousel",
  props: {
    cover: String
  },
  data() {
    return {
      tournaments: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("tournaments.json")
        .then(
          response => (this.tournaments = response.data.filter(t => t.active))
        );
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    TournamentCard
  }
};
</script>

<style scoped lang="sass">
.tournament-carousel
  .title-lined
    margin-bottom: -20px
  // margin-top: 80px
</style>
